/**
 * 推广管理
 */
import type { PageContext } from '@zto/zpage'
import { addEditDialog, logDialog } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { commonOptions } from '@/config/options'
import { PromotionTypeName, ListingStatusName, ScopeTypeName, ListingStatus } from '@/config/enums'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/oms/AdminMktPromotionQueryController/queryPage'
      },
      add: {
        label: '新增推广单',
        api: '/cabinet/admin/oms/AdminMktPromotionCommandController/create',
        dialog: addEditDialog('add'),
        successMessage: '新增成功！'
      },
      edit: {
        label: '编辑',
        api: '/cabinet/admin/oms/AdminMktPromotionCommandController/edit',
        dialog: addEditDialog('edit'),
        successMessage: '编辑成功！'
      },
      grounding: {
        label: '上架',
        api: '/cabinet/admin/oms/AdminMktPromotionCommandController/editStatus',
        payload: {
          promotionCode: '${data.row.promotionCode}',
          status: ListingStatus.ON
        },
        message: '是否确认上架?'
      },
      undercarriage: {
        label: '下架',
        api: '/cabinet/admin/oms/AdminMktPromotionCommandController/editStatus',
        payload: {
          promotionCode: '${data.row.promotionCode}',
          status: ListingStatus.OFF
        },
        message: '是否确认下架?'
      },
      view: {
        label: '详情',
        dialog: addEditDialog('view')
      },
      log: {
        label: '日志',
        dialog: logDialog()
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      items: [
        { type: 'input', prop: 'promotionCode', label: '推广单ID', span: 6 },
        {
          label: '推广类型',
          type: 'select',
          prop: 'promotionType',
          options: commonOptions.promotionType,
          span: 6
        },
        {
          label: '状态',
          type: 'select',
          prop: 'status',
          options: commonOptions.listingStatus,
          span: 6
        }
      ],
      afterSearch: ({ app, searchParams }: any) => {
        if (searchParams.supplierCode) {
          searchParams.isCheck = true
        } else {
          searchParams.isCheck = false
        }
        app.setPageSearchData('isCheck', searchParams.isCheck)
      }
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 150,
        items: [
          { action: 'edit', visibleOn: `this.data.row.status === '${ListingStatus.OFF}'` },
          {
            action: 'grounding',
            visibleOn: `this.data.row.status === '${ListingStatus.OFF}'`
          },
          {
            action: 'undercarriage',
            visibleOn: `this.data.row.status === '${ListingStatus.ON}'`
          },
          { action: 'view' },
          { action: 'log' }
        ]
      },
      columns: [
        { label: '推广单ID', prop: 'promotionCode', minWidth: 180 },
        {
          label: '推广类型',
          minWidth: 150,
          formatter: (row: any) => {
            return (PromotionTypeName as any)[row.promotionType] || row.promotionType
          }
        },
        {
          label: '生效范围',
          minWidth: 120,
          formatter: (row: any) => {
            return (ScopeTypeName as any)[row.scopeType] || row.scopeType
          }
        },
        {
          label: '上下架状态',
          minWidth: 120,
          // cell: { style: { color: 'red' } },
          formatter: (row: any) => {
            return (ListingStatusName as any)[row.status] || row.status
          }
        },
        { label: '创建人', prop: 'creator', minWidth: 150 },
        {
          label: '创建时间',
          minWidth: 150,
          formatter: (row: any) => {
            return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
          }
        }
      ]
    }
  }
}
